export const SAVE_PAGE = 'SAVE_PAGE';
export const SAVE_PAGE_SUCCESS = 'SAVE_PAGE_SUCCESS';
export const SAVE_PAGE_FAILURE = 'SAVE_PAGE_FAILURE';
export const ADD_PAGE_TO_THE_LIST = 'ADD_PAGE_TO_THE_LIST';
export const UPDATE_PAGE_IN_THE_LIST = 'UPDATE_PAGE_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/PageForm/actionTypes.js